<template>
  <div
    class="sc-message--carousel"
    :style="colors[messageCarousel.direction || 'received']"
  >
    <div v-for="(message, idx) in messageCarousel.data.elements" :key="idx">
      <div class="sc-message--carousel-element-wrapper">
        <div v-show="counter === idx" class="sc-message--carousel-element">
          <div
            v-show="'image_url' in message"
            :style="{
              backgroundImage:
                'image_url' in message ? `url('${message.image_url}')` : 'none',
            }"
            class="sc-message--carousel-element-image"
          ></div>
          <div class="sc-message--carousel-element-description">
            <h3 class="sc-message--title">{{ message.title }}</h3>
            <p
              v-if="message.subtitle"
              v-html="processContent(message.subtitle)"
            ></p>
          </div>
          <buttons-message
            v-if="message.buttons"
            :message="{ data: { buttons: message.buttons } }"
          />
          <button
            v-if="counter > 0"
            class="sc-message--carousel-element-handler-button left-button"
            @click.self.stop="counter--"
            :style="colors[messageCarousel.direction || 'received']"
          >
            <span @click.self.stop="counter--" class="chevron left"></span>
          </button>
          <button
            v-if="counter < messageCarousel.data.elements.length - 1"
            class="sc-message--carousel-element-handler-button right-button"
            @click.self.stop="counter++"
            :style="colors[messageCarousel.direction || 'received']"
          >
            <span @click.self.stop="counter++" class="chevron right"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonsMessage from './ButtonsMessage.vue';
export default {
  name: 'CarouselMessage',
  inject: {
    colors: {
      type: Object,
    },
  },
  data() {
    return {
      counter: 0,
    };
  },
  props: {
    messageCarousel: {
      type: Object,
      required: true,
      default() {
        return {
          data: {
            elements: [],
            buttons: [],
          },
        };
      },
    },
  },
  components: {
    ButtonsMessage,
  },
  computed: {
    bgImageStyle() {
      return this.message && this.message.image_url
        ? 'url(' + this.message.image_url + ')'
        : 'none';
    },
  },
  methods: {
    processContent(string) {
      let result = this.truncate(string, 50);
      result = this.linebreak(string);
      return result;
    },
    truncate(string, length = 100) {
      return string.length > length ? string.substr(0, length) + '...' : string;
    },
    linebreak(string) {
      return string.replace(/\n/g, '<br />');
    },
  },
};
</script>

<style lang="scss" scoped>
.sc-message--carousel {
  border-radius: 10px;
  position: relative;
  width: 90%;
  min-width: 180px;
}
.sc-message--carousel-element-wrapper {
  width: 100%;
}
.sc-message--carousel-element {
  padding: 1rem;
  min-width: 100px;
}
.sc-message--carousel-element-description {
  width: 100%;
}
.sc-message--carousel-element-image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 150px;
}
.sc-message--carousel-element-handler-button {
  border: none;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  cursor: pointer;
}
.sc-message--carousel-element-handler-button.left-button {
  left: 0;
  transform: translateY(-50%) translateX(-100%);
  border-radius: 4px 0 0 4px;
}
.sc-message--carousel-element-handler-button.right-button {
  right: 0;
  transform: translateY(-50%) translateX(100%);
  border-radius: 0 4px 4px 0;
}
.chevron::before {
  border-style: solid;
  border-width: 0.25em 0.25em 0 0;
  content: '';
  display: inline-block;
  height: 0.7em;
  position: relative;
  transform: rotate(-45deg);
  vertical-align: middle;
  width: 0.7em;
}
.chevron.left:before {
  left: 0.25em;
  transform: rotate(-135deg);
}
.chevron.right:before {
  left: 0;
  transform: rotate(45deg);
}
.sc-message--title {
  font-size: 1rem;
  font-weight: 600;
  padding: 0.5rem 0;
}
</style>
